var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('a',{on:{"click":_vm.downloadReports}},[_vm._v("Download Reports")])])])}
var staticRenderFns = []

export { render, staticRenderFns }